import React          from 'react';
import { FormFields } from '@widesk-ui/components/form/Form';
import { FormTools }  from '@widesk-ui/components/form/Form';

type FormContextType<T extends FormFields> = { fields: T; tools: FormTools<T> }

const FormContext = React.createContext<FormContextType<any>>({ fields: {}, tools: {} as any });

export default FormContext;
